import React, { FC } from "react";
import classnames from "classnames";

import ButtonBase from "../ButtonBase";
import { IButtonBaseProps } from "../ButtonBase/types";

import "./styles.scss";

export const Button: FC<IButtonBaseProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <ButtonBase
      className={classnames("ams-button--regular", className)}
      {...props}
    >
      {children}
    </ButtonBase>
  );
};
